'use client'

import { useQuery } from '@apollo/client'
import { Box, Typography } from '@mui/material'
import { AspectRatio } from '@radix-ui/react-aspect-ratio'
import { useMemo } from 'react'
import { Trans } from 'react-i18next'
import { GetVideoPreviewModalDocument, GetVideoPreviewModalQuery } from '~/__generated__/graphql'
import { Colors } from '~/libs/mui/theme'
import { PlayerBase } from './PlayerBase'

type Props = {
  id: string
}

export const TrailerPlayer = ({ id }: Props) => {
  const { data, loading } = useQuery<GetVideoPreviewModalQuery>(GetVideoPreviewModalDocument, {
    variables: { id },
  })
  const src = useMemo(() => data?.originalVideo?.trailer?.fileUrl || undefined, [data])
  const duration = useMemo(() => {
    const originDuration = data?.originalVideo?.trailer?.duration

    return (originDuration?.minutes || 0) * 60 + (originDuration?.seconds || 0)
  }, [data])
  const vtts = useMemo(() => data?.originalVideo?.trailer?.vtts || [], [data])
  const title = useMemo(() => data?.originalVideo?.title || '', [data])

  if (!loading && !src) {
    return (
      <AspectRatio ratio={16 / 9}>
        <Box
          display='flex'
          alignItems='center'
          justifyContent='center'
          width='100%'
          height='100%'
          bgcolor={Colors.color0D0D0E}
          borderRadius='8px'
        >
          <Typography>
            <Trans i18nKey='no_trailer' />
          </Typography>
        </Box>
      </AspectRatio>
    )
  }

  return (
    <PlayerBase
      title={title}
      src={src}
      duration={duration}
      vtts={vtts}
      hlsParameter=''
      loggers={{}}
    />
  )
}
